import {
  createJSONFormDataWithMultipleAttachments,
  postFormRequest,
  postRequest,
} from '@/helpers/request';

const BASE = '/marketing_module/partner_popups';

function popupFormData(payload, { desktopImage, mobileImage } = {}) {
  const names = [];
  const files = [];

  if (desktopImage) {
    names.push('image_desktop');
    files.push([desktopImage]);
  }
  if (mobileImage) {
    names.push('image_mobile');
    files.push([mobileImage]);
  }

  return createJSONFormDataWithMultipleAttachments(payload, files, names);
}

export async function apiGetPartnerPopups(query) {
  return postRequest(`${BASE}/list/`, query);
}

export async function apiGetPartnerPopup(id) {
  return postRequest(`${BASE}/detail/`, { id });
}

export async function apiCreatePartnerPopup(payload, images) {
  return postFormRequest(`${BASE}/create/`, popupFormData(payload, images));
}

export async function apiUpdatePartnerPopup(payload, images) {
  return postFormRequest(`${BASE}/update/`, popupFormData(payload, images));
}

export async function apiDeletePartnerPopup(id) {
  return postRequest(`${BASE}/delete/`, { id });
}

export async function apiGetActivePartnerPopup() {
  const result = await postRequest('/api/partner-popups/active/');
  return result.popup;
}

export async function apiRecordPartnerPopupView(popupId) {
  return postRequest('/api/partner-popups/impression/', { popup_id: popupId });
}

export async function apiRecordPartnerPopupCtaClick(popupId) {
  return postRequest('/api/partner-popups/cta/click/', { popup_id: popupId });
}
